import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Store } from "@ngrx/store";
import { AppState } from "../states/app-state.interface";
import { AppConfigActions } from "../states/app";

@Injectable()
export class AppRepository {
  public currentPage$: Observable<string> = this.store.select(store => store.app.page);
  public internetConnection$: Observable<boolean> = this.store.select(store => store.app.internetConnection);
  public isOffline$: Observable<boolean> = this.store.select(store => store.app.isOffline);

  constructor(
    private store: Store<AppState>,
    private appConfigActions: AppConfigActions,
  ) { }

  public setPage(pageName: string) {
    this.store.dispatch(this.appConfigActions.setPage({ page: pageName }));
  }

  public setInternetConnection(connection: boolean) {
    this.store.dispatch(this.appConfigActions.setInternetConnection({ connection }));
  }

  public toggleOfflineMode(): void {
    this.store.dispatch(this.appConfigActions.toggleOfflineMode());
  }
}



// WEBPACK FOOTER //
// ./src/repositories/app.repository.ts